import { DatePipe } from '@angular/common';
import { LowerCasePipe } from '../../../filters/lower-case.pipe';
import { TranslatePipe } from '../../../filters/translate.pipe';
import { PreVisitThankYouComponentComponent } from '../../../components/pre-visit/thank-you/pre-visit-thank-you.component';
import { ItemNotificationComponent } from '../../../components/item-notification/item-notification.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Config from '../../../utils/config.service';
import Session from '../../../utils/session.service';
import UrlUtil from '../../../utils/url-util.service';
import RoutingService from '../../../services/routing.service';
import RestService from '../../../services/core-rest.service';
import PreVisitRecordTicketForPersonService from '../../../services/pre-visit-record-ticket-for-person.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import { PanelDirective } from '../../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'prescription-checkout',
	templateUrl: './prescription-checkout.component.html',
	imports: [
		CommonModule, PanelDirective, DatePipe, LowerCasePipe,
		TranslatePipe, PreVisitThankYouComponentComponent, ItemNotificationComponent, 
		ReactiveFormsModule, FormsModule
	]
})
export default class PreVisitPrescriptionCheckoutComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private routingService: RoutingService = inject(RoutingService);
	private restService: RestService = inject(RestService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	vm: any = undefined;
	watcher: any = undefined;
	mainForm: FormGroup;
	
	constructor(private fb: FormBuilder) {
		this.vm = this;
		this.mainForm = this.fb.group({
			termsCheckbox: [false, Validators.requiredTrue],
			ppCheckbox: [false, Validators.requiredTrue]
		});
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			var item: any = window.sessionStorage.getItem(this.config.getBookingConfig().Instant.STORAGE_KEY);
			if (item) {
				this.vm.booking = JSON.parse(item);
			}
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	onResolve() {
		this.vm.gdprDisclaimerTranslated = this.angularFilterHelperService.translate('Modal.Content.Consents_Gdpr_Disclaimer');
		this.vm.showOnlyThankYouSection = false;
		this.vm.isSaving = false;
		this.vm.isRecordTicketForPerson = false;
		this.vm.thankYouInformationSection = ""
			+ "<p>" + this.angularFilterHelperService.translate('PreVisit.Prescription_Checkout.Application_Forwarded') + "</p>"
			+ "<p>" + this.angularFilterHelperService.translate('PreVisit.Prescription_Checkout.Contacted_In') + "</p>"
			+ "<p>" + this.angularFilterHelperService.translate('PreVisit.Prescription_Checkout.Receive_SMS') + "</p>";
		
		this.vm.serviceId = this.angularRoutingHelperService.getRouteParam('serviceId');
		this.vm.user = this.session.getSession().user;
		this.vm.isOpen = { service: true, consents: true };
		this.vm.isRecordTicketForPerson = !!this.preVisitRecordTicketForPersonService.getPatient();
		
		if (this.vm.booking) {
			this.vm.booking.platform = 'BROWSER';
			this.vm.booking.consents = {};
			this.updateBookingInStorage(this.vm.booking);
		}
		
		this.setConsentLinksByLang();
		
		var currentSession = this.session.getSession();
		this.watcher = this.angularHelperService.createInterval(() => {
			var newSession = this.session.getSession();
			if (!this.angularHelperService.isEqual(newSession, currentSession)) {
				this.handleSessionChange(newSession, currentSession);
				currentSession = Object.assign({}, newSession);
			}
		}, 300);
		
		this.vm.handleFormSubmit = this.submit;
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		
		if (mainForm.invalid) {
			this.vm.isOpen.consents = true;
			return;
		}
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (this.vm.isSaving) {
			return;
		}
		
		this.vm.isSaving = true;
		var submitData: any = this.vm.booking ? this.vm.booking : {};
		submitData = this.preVisitRecordTicketForPersonService.addRecordTicketForPersonData(submitData);
		this.restService.savePreVisitNewPrescriptionRequest(submitData)
			.then((response) => {
				window.sessionStorage.removeItem(this.config.getBookingConfig().Instant.STORAGE_KEY);
				this.vm.preVisitTicketId = response.id
				this.vm.showOnlyThankYouSection = true;
				this.vm.isSaving = false;
				deferred.resolve();
			})
			.catch((error) => {
				alert("THIS SERVICES IS DEPRECATED. PLEASE NOTIFY SERVICE PROVIDER ABOUT THE ERROR!");
				deferred.reject(error);
				this.vm.isSaving = false;
				console.log(error);
			});
		
		return deferred.promise;
	}
	
	handleSessionChange(newSess, oldSess) {
		if (this.angularHelperService.equals(newSess, oldSess) || !newSess) return;
		this.vm.user = newSess.user;
	}
	
	setConsentLinksByLang() {
		this.vm.links = {};
		if (this.vm.user.origin == 'minudoc.ee') {
			this.vm.links.tos = this.urlUtil.createPublicUrl({
				'et_EE': '/tto/kasutustingimused',
				'en_GB': '/hsp/terms-of-service',
				'ru_RU': '/pmu/uslovija-ispolzovanija',
				'fi_FI': '/tpt/kayttoehdot'
			});
			this.vm.links.pp = this.urlUtil.createPublicUrl({
				'et_EE': '/tto/privaatsuspoliis',
				'en_GB': '/hsp/privacy-policy',
				'ru_RU': '/pmu/politika-konfidencialnosti',
				'fi_FI': '/tpt/tietosuojakaytanto'
			});
		} else {
			var locale: any = (this.vm.user && this.vm.user.deviceLanguage) || 'en_GB';
			this.vm.links.tos = this.config.getSiffiPublicWebUrl(locale, '/hsp/terms-of-service');
			this.vm.links.pp = this.config.getSiffiPublicWebUrl(locale, '/hsp/privacy-policy');
		}
		
		this.vm.termsConsent = this.angularHelperService.trustAsHtml(
			this.angularFilterHelperService.translate('Modal.Content.AgreeTo')
				.replace('%s', '<a href="' + this.vm.links.tos +'" target="_blank">' + this.angularFilterHelperService.translate('Modal.Content.ToS') + '</a>')
		);
		this.vm.ppConsent = this.angularHelperService.trustAsHtml(
			this.angularFilterHelperService.translate('Modal.Content.HaveRead')
				.replace('%s', '<a href="' + this.vm.links.pp +'" target="_blank">' + this.angularFilterHelperService.translate('Modal.Content.PrivacyPolicy') + '</a>')
		);
	}
	
	updateBookingInStorage(data) {
		window.sessionStorage.setItem(this.config.getBookingConfig().Instant.STORAGE_KEY, JSON.stringify(data));
	}
	
}
